import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

import { desktop } from './check-res.js'

gsap.registerPlugin(ScrollTrigger)

window.addEventListener('load', () => {
	ScrollTrigger.create({
		trigger: '.editions__products',
		endTrigger: '.editions__container-inner',
		scrub: true,
		pin: true,
		start: 'top top',
		end: 'bottom bottom',
	})

	if (desktop) {
		const productSections = document.querySelectorAll('.editions__section')

		gsap.set('.card-flip', {
			transformStyle: 'preserve-3d',
			transformPerspective: 1000,
		})

		const card = document.querySelector('.card-flip')
		const front = card.querySelector('.card-flip__front')
		const back = card.querySelector('.card-flip__back')

		gsap.set(back, { rotationY: -180 })

		productSections.forEach((section, index) => {
			const changeProduct = (opacity1, opacity2) => {
				card.querySelector('.editions__product-1').style.opacity = opacity1
				card.querySelector('.editions__product-3').style.opacity = opacity2
			}
			const flip = (section, frontDeg, backDeg, cardFlip) => {
				gsap
					.timeline({
						scrollTrigger: {
							trigger: section,
							scrub: true,
							start: 'top bottom',
							end: 'top+=200rem center',
						},
					})
					.to(front, { duration: 1, rotationY: frontDeg })
					.to(
						back,
						{
							duration: 1,
							rotationY: backDeg,
						},
						0
					)
					.to(card, { z: cardFlip ? 1 : 0, scale: 1.1 }, 0)
					.to(
						card,
						{
							z: cardFlip ? 0 : 1,
							scale: 1,
							onComplete: () => {
								if (index === 1) {
									changeProduct(0, 1)
								}
							},
							onReverseComplete: () => {
								if (index === 1) {
									changeProduct(1, 0)
								}
							},
						},
						0.5
					)
			}

			if (index === 1) {
				gsap.to(section, {
					scrollTrigger: {
						trigger: section,
						onEnter() {
							flip(section, 180, 0, true)
						},
						onLeaveBack() {
							flip(section, 0, -180, false)
						},
					},
				})
			} else if (index === 2) {
				gsap.to(section, {
					scrollTrigger: {
						trigger: section,
						onEnter() {
							flip(section, 360, 180, false)
						},
						onLeaveBack() {
							flip(section, 180, 0, true)
						},
					},
				})
			}
		})
	}
})
